import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import styled from 'styled-components';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Typography, Box } from '@mui/material';
import { Grid } from '@mui/material';
import '../../microservice/container/sidebar.css';
import '../../Style/defaultstyle.css'
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import Sidebar from '../../container/Sidebar/Sidebar';
import '../../Style/defaultstyle.scss'
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-en';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import FooterEn from '../../detailpageVN/Page/component/footeren';
import HeaderEn from '../../detailpageVN/Page/component/headeren';
import SidebarEn from '../../container/Sidebar/Sidebar-en';

const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;



// Titlecloudcompute
function EventSourcingENG() {
    const isMobile = useIsMobile();

    return (
        <Sysfont className='App'>
            <HeaderEn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarEn />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Event Sourcing")} */}

                        <BoxContent>
                            <BoxText><p class="typo-14">• Serverless services that implement CQRS (Command Query Responsibility Segregation)</p></BoxText>
                            <BoxText><p class="typo-14">• All state-changing events in the application are stored in order, unlike traditional approaches where only the final state value is stored.</p></BoxText>
                            <ImageWrap src="https://www.hanbiro.com/cloud/library2/event-sourcing/event-sourcing-1.svg"></ImageWrap>
                        </BoxContent>
                        <DividerComponent />
                        <BoxContent>
                            <Box sx={TitleWrap}><Typography className="sub-title normal" sx={CardTitle} variant="h6"><p class="typo-21 typo-medium typo-black">Characteristics</p></Typography></Box>
                            <BoxText><p class="typo-14">• Independent scalability and maintenance per microservice, with rapid build and deployment capabilities.</p></BoxText>
                            <BoxText><p class="typo-14">• Errors are isolated to specific functionalities, enabling quick fixes and recovery.</p></BoxText>
                            <BoxText><p class="typo-14">• Asynchronous write operations allow screen transitions without waiting for a response.</p></BoxText>
                            <BoxText><p class="typo-14">• Read-side database design:</p></BoxText>
                            <BoxSubText><p class="typo-14">- Schema is optimized for queries.</p></BoxSubText>
                            <BoxSubText><p class="typo-14">- Enables highly efficient reads through simplified queries.</p></BoxSubText>
                            <BoxSubText><p class="typo-14">- Database replacement, full reconstruction, and historical state replay are possible.</p></BoxSubText>
                        </BoxContent>
                        <DividerComponent />

                        {/*}
                        <BoxContent>
                            <Box sx={TitleWrap}><Typography className="titlecard normal" sx={CardTitle} variant="h6">• 가격</Typography></Box>
                            <br/>
                            <CommonTable header={config.tb4_header} content={config.tb4_content} />
                            <br/>
                            <CommonTable header={config.tb5_header} content={config.tb5_content} />
                        </BoxContent>
                        */}
                        <BoxContent>
                            <Box><Typography className="sub-title normal" sx={CardTitle} variant="h6"><p class="typo-21 typo-medium typo-black">CQRS on AWS</p></Typography></Box>
                            {/* {Imagecloudcompute("https://www.hanbiro.com/cloud/library2/event-sourcing/event-sourcing-2.svg")} */}
                            <ImageWrap src="https://www.hanbiro.com/cloud/library2/event-sourcing/event-sourcing-2.svg"></ImageWrap>
                        </BoxContent>

                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>


            <FooterEn />
        </Sysfont>
    );
};

const BoxSubText = styled.div`
  margin-left: 7%;
`

const CardTitle = {
    textAlign: "left",
    fontWeight: "bold",
    fontFamily: "맑은고딕, Dotum, 돋움, sans-serif !important;"
}

const TitleWrap = {
    height: "40px",
}


// const Box = styled.div`
//   @media only screen and (max-width: 767px){
//     font-size: 80%;
//   }
// `

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 4px;
    margin-top: 20px;
    margin-bottom: 20px; */}
    text-align: left;
`

const BoxText = styled.div`
    margin: 0px !important;
    line-height: 2em;
`

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

export default EventSourcingENG;
